import { defineFcm } from '../shared/factory';

export const FCM_HOMEPAGE_TIKTOK_SOURCE_ENABLED = defineFcm('homepage_tiktok_source_enabled')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-narwhal',
		scope: 'corgi-front-end',
		supportedGroups: { global: true },
		context: 'Homepage',
		description: `Accepts TikTok links and shows the TikTok badge in the homepage social post hero's multi-source arms (homepage_input_sources).
		When off, a pasted TikTok link reads as an unsupported source. The single_source arm always accepts TikTok.`,
	});
